<template>
  <div>
    <QHloading v-if="QHloading"></QHloading>
    <div class="QHpostionDaohang" style="width: 380px">
      <div class="box on">
        <span>载具实况➥分布图 &nbsp;&nbsp;&nbsp;&nbsp;<font class="btn"  @click="getData('chuan',200)" style="width: 30%;">刷新</font></span> 
        <div class="flex-between">
          <font class="btn" :class="{ on: isZhuangtai == '1000' }" @click="getZhuangtai('1000')" style="width: 100%">全部状态</font>
          <font class="btn" :class="{ on: isZhuangtai == '100' }" @click="getZhuangtai('100')" style="width: 100%">在线</font>
          <font class="btn" :class="{ on: isZhuangtai == '200' }" @click="getZhuangtai('200')" style="width: 100%;">离线</font>
        </div>
        <div class="flex-between" style="margin-top: 20px;" v-if="false">
          <font class="btn" :class="{ on: isEvent == 'all' }" @click="getData('all',100)" style="width: 100%">全部车船箱</font>
          <font class="btn" :class="{ on: isEvent == 'che' }" @click="getData('che',100)" style="width: 100%">清运车辆</font>
          <font class="btn" :class="{ on: isEvent == 'chuan' }" @click="getData('chuan',100)" style="width: 100%;">清运船舶</font>
          <font class="btn" :class="{ on: isEvent == 'xiang' }" @click="getData('xiang',100)" style="width: 100%; margin-right: 0">清运车厢</font>
        </div>
        <div class="tabBox flex-between" style="margin-top: 20px">
          <font class="btn2" :class="{ on: keywordType == 100 }" @click="searchKeywordTypeTab(100)">按号牌</font>
          <font class="btn2" :class="{ on: keywordType == 200 }" @click="searchKeywordTypeTab(200)">按城市</font>
          <font class="btn2" :class="{ on: keywordType == 300 }" @click="searchKeywordTypeTab(300)">按区县</font>
          <font class="btn2" :class="{ on: keywordType == 400 }" @click="searchKeywordTypeTab(400)">按街道</font>
          <font class="btn2" :class="{ on: keywordType == 800 }" @click="searchKeywordTypeTab(800)" style="margin-right: 0">按公司</font>
        </div>
        <div class="flex-center InputBox">
          <Input v-model="keyword" :placeholder="placeholder" class="input" />
          <div class="btn on" @click="getData('all',200)" style="margin-right: 0">搜一搜</div>
        </div>
        <div class="msg" style="margin-top:5px;font-size:12px;">{{ msg }}</div>
      </div>
    </div>
    <div class="QHzuobiaoMapPage" id="map"></div>
    <!-- 固定位置信息窗组件 -->
    <div v-if="showInfoWindow" class="fixed-info-window" >
      <div class="info-header" v-if="properties.restrictVehicleType == 200"  @click="$refs.shipdetailed.hiPop(properties.id)">
        <span style="cursor: pointer;color: blue;font-size: 18px;">号牌：{{properties.licensePlate}}</span>
        <div class="close-btn" @click="showInfoWindow = false">×</div>
      </div>
      <div class="info-header" v-else-if="properties.restrictVehicleType == 100" @click="$refs.cardetailed.hiPop(properties.id)">
        <span style="cursor: pointer;color: blue;font-size: 18px;">号牌：{{properties.licensePlate}}</span>
        <div class="close-btn" @click="showInfoWindow = false">×</div>
      </div>
      <div class="info-header" v-else-if="properties.restrictVehicleType == 300" @click="$refs.boxdetailed.hiPop(properties.id)">
        <span style="cursor: pointer;color: blue;font-size: 18px;">号牌：{{properties.licensePlate}}</span>
        <div class="close-btn" @click="showInfoWindow = false">×</div>
      </div>
      <div class="info-content">
        <div  class="MultiMarker">
          <div class="p1"></div>
          <div class="p0">单位：{{properties.orgName}}</div>
          <div class="p0">名称：{{properties.name}}</div>
          <div class="p3">额载：{{properties.capacity}}m³</div>
          <div class="p3">位置：{{properties.Gps_cityName}}{{properties.Gps_districtName}}{{properties.Gps_streetName}}{{properties.Gps_address}}</div>
          <div class="p3">状态：
            <span v-if="isOnline(properties.Gps_gpsTime)">GPS在线</span>
            <span v-else>GPS离线</span>
          </div>
          <div class="p3">速度：{{properties.Gps_speed}}KM/小时</div>
          <div class="p3" >执运：
            <span v-if="properties.electronicbillNO == '空闲中'">{{properties.electronicbillNO}}</span>
            <span v-else class="electronicbill-link"  @click="$QHopen.url($httpServerH5('/electronicbilldetailed?NO=' + properties.electronicbillNO), 750, 80)">联单{{properties.electronicbillNO}}</span>
          </div>
          <div class="p3" >最近执运：
            <span v-if="properties.electronicbillNO400 == '暂无清运记录'">{{properties.electronicbillNO400}}</span>
            <span v-else class="electronicbill-link"  @click="$QHopen.url($httpServerH5('/electronicbilldetailed?NO=' + properties.electronicbillNO400), 750, 80)">联单{{properties.electronicbillNO400}}</span>
          </div>
          <div class="p3">定位：{{ $timeFmt(properties.Gps_gpsTime, "YYYY年MM月DD HH:mm") }}</div>
        </div>
      </div>
    </div>
    <shipdetailed ref="shipdetailed" ></shipdetailed>
    <cardetailed ref="cardetailed" ></cardetailed>
    <boxdetailed ref="boxdetailed" ></boxdetailed>
  </div>


      

</template>



<script>
import shipdetailed from "./block/shipdetailed/detailed";
import cardetailed from "./block/cardetailed/detailed";
import boxdetailed from "./block/boxdetailed/detailed";
export default {
  components: {
    shipdetailed,cardetailed,boxdetailed,
  },
  data() {
    return {
      showInfoWindow: false,
      QHloading: true,
      keyword: "",
      map: null,
      maskLayer: null,
      properties:"",
      //关键词搜索
      placeholder: "请输入载具号牌",
      keywordType: 100,
      isZhuangtai:1000,
      keyword: "",
      msg: "",

      //查询对象
      isEvent: "chuan",
    };
  },

  mounted() {
    this.keyword = this.$getUrlParams("keyword") || "";
    this.getData("chuan",100);
  },

  methods: {
    // +----------------------------------------------------------------------
    // | @Des:关键词方式搜索
    // +----------------------------------------------------------------------
    searchKeywordTypeTab: function (keywordType) {
      this.keyword = "";
      this.keywordType = keywordType;
      if (keywordType == 100) {
        this.placeholder = "请输入载具号牌";
      }
      if (keywordType == 200) {
        this.placeholder = "请输入城市,如广州";
      }
      if (keywordType == 300) {
        this.placeholder = "请输入区县,如荔湾区";
      }
      if (keywordType == 400) {
        this.placeholder = "请输入街道,如黄村街道";
      }
      if (keywordType == 800) {
        this.placeholder = "请输入所属运输公司名称";
      }
    },

      // +----------------------------------------------------------------------
    // | @Des:关键词方式搜索
    // +----------------------------------------------------------------------
    getZhuangtai: function (isZhuangtai) {
      this.isZhuangtai = isZhuangtai;
      this.getData(this.isEvent,200);
    },

    // +----------------------------------------------------------------------
			// | Desc:搜索提示信息
			// +----------------------------------------------------------------------
			searchMsg: function(count) {
				var msg = ""
				if (this.keywordType == 100) {
					msg = '搜索号牌➥“' + this.keyword + '”➥搜索到' + count;
				};
				if (this.keywordType == 200) {
					msg = '搜索城市➥“' + this.keyword + '”➥搜索到' + count;
				};
				if (this.keywordType == 300) {
					msg = '搜索区县➥“' + this.keyword + '”➥搜索到' + count;
				};
				if (this.keywordType == 400) {
					msg = '搜索街道➥“' + this.keyword + '”➥搜索到' + count;
				};
				if (this.$isblank(this.keyword)) {
					msg = '您授权区域“' + this.$getCityFuqin("name") + '”➥该地区共' + count;
				};
				if (!this.$isblank(msg)) {
					msg += "条数据";
				};
				this.msg = msg;
			},

    //获取地图标记数据
    getData(isEvent,type) {
      if(type == 200){
        console.log(this.isEvent);
      }else{
        this.isEvent = isEvent;
        console.log(this.isEvent);
      }
      
      var that = this;
      var https = {
        type: "isApi",
        isLoading: "isLoadingPop",
        api: this.$api.getZaijuZuobiao,
        parameter: {
          isZhuangtai: this.isZhuangtai,
          keywordType: this.keywordType,
          keyword: this.keyword,
          isEvent: this.isEvent,
        },
      };
      that.$httpsApi(https, function (res) {
        if (that.map) {
          that.map.destroy();
        }

        //整合坐标数据
        var list = that.getFmtData(res.data);
        that.searchMsg(res.count||0);

        //执行地图初始化
        that.mapInit(list);
      });
    },

    //格式化成地图需要的格式数据(坐标)
    getFmtData(data) {
      var that = this;
      var list = [];
      for (var i = 0; i < data.length; i++) {
        var value = data[i];
        var coordinate = that.$commaToarr(value["coordinates"]);
        var obj = {};
        if (value["restrictVehicleType"] == 100) {
          if (value["Gps_status"] == 1) {
            value["markerId"] = "markerChe1";
          } else {
            value["markerId"] = "markerChe3";
          }
        }
        if (value["restrictVehicleType"] == 200) {
          if (value["Gps_status"] == 1) {
            value["markerId"] = "markerChuan1";
          } else {
            value["markerId"] = "markerChuan3";
          }
        }

        if (value["restrictVehicleType"] == 300) {
          if (value["Gps_status"] == 1) {
            value["markerId"] = "markerXiang1";
          } else {
            value["markerId"] = "markerXiang3";
          }
        }

        if (!that.$isblank(coordinate) && coordinate.length == 2) {
          value["lat"] = parseFloat(coordinate[0]);
          value["lng"] = parseFloat(coordinate[1]);
          list.push(value);
        }
      }
      return list;
    },

    // 地图初始化
    async mapInit(list) {
      try {
        // 初始化地图
        this.initializeMap(list);

        // 加载行政区划数据
        // const polygons = await this.loadDistrictPolygons();

        // 处理并显示行政区划
        // this.processPolygons(polygons);

        // 创建坐标标记点
        this.createMarker(list);

        //关闭加载层
        setTimeout(() => {
          this.QHloading = false;
        }, 500);
      } catch (error) {
        console.error("地图初始化失败:", error);
      }
    },

    // 创建地图标记点
    createMarker(polygon) {
      if (!this.map) {
        console.error("地图未初始化");
        return;
      }

      // 清除旧标记层（如果存在）
      if (this.markerLayer) {
        this.markerLayer.setMap(null);
      }

      // 创建新标记层
      this.markerLayer = new TMap.MultiMarker({
        map: this.map,
        cursor: "pointer",
        zIndex: 100,
        styles: {
          //在线车
          markerChe1: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/che2.png"),
            anchor: { x: 16, y: 32 },
          }),
          //离线车
          markerChe3: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/che3.png"),
            anchor: { x: 16, y: 32 },
          }),
          //在线船
          markerChuan1: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/chuan1.png"),
            anchor: { x: 16, y: 32 },
          }),
          //离线船
          markerChuan3: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/chuan3.png"),
            anchor: { x: 16, y: 32 },
          }),
          //在线车
          markerXiang1: new TMap.MarkerStyle({
          width: 25,
          height: 35,
          src: require("@/assets/xiang2.png"),
          anchor: { x: 16, y: 32 },
          }),
          //离线车
          markerXiang3: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: require("@/assets/xiang3.png"),
            anchor: { x: 16, y: 32 },
          }),
        },
        geometries: polygon.map((point) => ({
          position: new TMap.LatLng(point.lat, point.lng),
          styleId: point.markerId,
          properties: {
            id: point.id,
            markerId: point.markerId,
            licensePlate: point.licensePlate,
            orgName: point.orgName,
            name: point.name,
            capacity: point.capacity,
            Gps_cityName: point.Gps_cityName,
            Gps_districtName: point.Gps_districtName,
            Gps_streetName: point.Gps_streetName,
            Gps_address: point.Gps_address,
            Gps_speed: point.Gps_speed,
            electronicbillNO: point.electronicbillNO,
            restrictVehicleType: point.restrictVehicleType,
            electronicbillNO400: point.electronicbillNO400,
            Gps_gpsTime: point.Gps_gpsTime,
          },
        })),
      });

      //初始化infoWindow
      var infoWindow = new TMap.InfoWindow({
        map: this.map,
        enableCustom: true,
        position: new TMap.LatLng(23.126419, 113.234015),
        //设置信息窗相对position偏移像素
        offset: {
          x: 0,
          y: 0,
        },
      });
      infoWindow.close(); //初始关闭信息窗关闭

      // 添加点击事件
      this.markerLayer.on("click", (evt) => {
          infoWindow.open(); //打开信息窗
          infoWindow.setPosition(evt.geometry.position); //设置信息窗位置
          var properties = evt.geometry.properties;
          this.properties = properties;
          this.showInfoWindow = true;
          var html = "<div class='MultiMarker'>";
          if (properties.licensePlate) {
            html += '<div class="p1">' + properties.licensePlate + "</div>";
          }
          if (properties.orgName) {
            html += '<div class="p0">单位：' + properties.orgName + "</div>";
          }
          if (properties.name) {
            html += '<div class="p0">名称：' + properties.name + "</div>";
          }
          if (properties.capacity) {
            html += '<div class="p3">额载：' + properties.capacity + "m³</div>";
          }
          if (properties.Gps_cityName) {
            html += '<div class="p3">位置：' + properties.Gps_cityName + properties.Gps_districtName + properties.Gps_streetName + properties.Gps_address + "</div>";
          }
          if (this.isOnline(properties.Gps_gpsTime)) {
            html += '<div class="p3">状态：GPS在线</div>';
          } else {
            html += '<div class="p3">状态：GPS离线</div>';
          }
          if (properties.Gps_speed) {
            html += '<div class="p3">速度：' + properties.Gps_speed + "KM/小时</div>";
          }
          if (properties.electronicbillNO) {
            html += '<div class="p3">执运：' + properties.electronicbillNO + "</div>";
          }
          if (properties.Gps_gpsTime) {
            html += '<div class="p3">定位：' + this.$timeFmt(properties.Gps_gpsTime, "YYYY年MM月DD日 HH:mm") + "</div>";
          }
          html += "</div>";
          infoWindow.setContent(html); //设置信息窗内容
        })
        .on("mouseout", () => {
          infoWindow.close();
        });
    },

    // 初始化地图基础配置
    initializeMap() {
      this.map = new TMap.Map("map", {
        center: new TMap.LatLng(23.126419, 113.234015),
        showLabel: false,
        zoom: 10,
        mapStyleId: "style9",
        showControl: false,
        baseMap: {
          type: "vector",
          // features: ["base", "building3d", "label", "building"],
          // features: ["base", "label", "poi", "road", "building"],
          features: [
          "base", "label", "poi", "building", 
          "land", "water", "green", "point"
        ],
        },
      });
    },

    // 加载行政区划数据
    async loadDistrictPolygons() {
      const district = new TMap.service.District({ polygon: 2 });
      var code = this.$FMTCode(this.$getCityFuqin("code"));
      if (this.$getCityFuqin("level") == 4) {
        var code = this.$FMTCode(this.$getUser("districtCode"));
      }

      const result = await district.search({ keyword: code });
      return new TMap.MultiPolygon({
        map: this.map,
        geometries: [],
      });
    },

    // 处理多边形数据
    processPolygons(polygons) {
      var code = this.$FMTCode(this.$getCityFuqin("code"));
      if (this.$getCityFuqin("level") == 4) {
        var code = this.$FMTCode(this.$getUser("districtCode"));
      }
      new TMap.service.District({ polygon: 2 }).search({ keyword: code }).then((result) => {
        result.result.forEach((level) => {
          level.forEach((place) => {
            // 生成多边形数据
            const geometries = place.polygon.map((polygon, index) => ({
              id: `${place.id}_${index}`,
              paths: polygon,
            }));

            // 更新多边形显示
            polygons.updateGeometries(geometries);

            // 计算并设置地图边界
            const bounds = this.calculateSafeBounds(place.polygon);
            this.map.fitBounds(bounds, { padding: 50 });

            // 创建遮罩层
            this.createMaskLayer(place.polygon);
          });
        });
      });
    },

    // 安全边界计算方法
    calculateSafeBounds(polygons) {
      // 初始化有效边界
      let swLat = 90,
        swLng = 180;
      let neLat = -90,
        neLng = -180;

      polygons.forEach((polygon) => {
        polygon.forEach((point) => {
          const lat = point.lat || point[0];
          const lng = point.lng || point[1];

          swLat = Math.min(swLat, lat);
          swLng = Math.min(swLng, lng);
          neLat = Math.max(neLat, lat);
          neLng = Math.max(neLng, lng);
        });
      });

      return new TMap.LatLngBounds(new TMap.LatLng(swLat, swLng), new TMap.LatLng(neLat, neLng));
    },

    // 创建区域镂空层
    createMaskLayer(targetPolygons) {
      if (this.maskLayer) {
        this.maskLayer.setMap(null);
      }

      // 转换所有多边形坐标并验证方向
      const processPolygon = (polygon) => {
        return polygon;
      };

      // 生成正确方向的外层路径（顺时针）
      var coverage = [new TMap.LatLng(-85, -180), new TMap.LatLng(-85, 180), new TMap.LatLng(85, 180), new TMap.LatLng(85, -180)];

      // 处理多个镂空区域
      const holes = targetPolygons
        .map((polygon) => {
          const validPolygon = processPolygon(polygon);
          if (validPolygon.length < 3) return null;
          return [...validPolygon].reverse(); // 逆时针
        })
        .filter((h) => h !== null);

      // 创建遮罩层
      try {
        this.maskLayer = new TMap.MultiPolygon({
          map: this.map,
          geometries: [
            {
              paths: [coverage, ...holes], // 合并所有路径
              styleId: "maskStyle",
            },
          ],
          styles: {
            maskStyle: new TMap.PolygonStyle({
              color: "rgba(0, 13, 57, 0.6)",
              showBorder: false,
              fillOpacity: 0.1,
              zIndex: 9999, // 设置层级高度，值越大越靠上
            }),
          },
          zIndex: 9999, // 设置层级高度，值越大越靠上
        });

        // 使用备用刷新方法
        setTimeout(() => {
          this.map.setCenter(this.map.getCenter());
          this.maskLayer.setZIndex(9999);
        }, 100);
      } catch (error) {
        console.error("遮罩层创建失败:", error);
      }
    },

     // +----------------------------------------------------------------------
    // | 通过时间判定设备是否在线
    // +----------------------------------------------------------------------
    isOnline(createdTime) {
      if (!createdTime) return false;
      const now = Math.floor(Date.now() / 1000);
      if((now - createdTime) <= 600) {
        return true;
      }else{
        return false;
      }
     
    },

    //生成覆盖可视区域的矩形
    createFullCoveragePolygon() {
      // 生成覆盖可视区域的矩形（考虑地图当前投影）
      const bounds = this.map.getBounds();
      return [bounds.getSouthWest(), new TMap.LatLng(bounds.getSouthWest().getLat(), bounds.getNorthEast().getLng()), bounds.getNorthEast(), new TMap.LatLng(bounds.getNorthEast().getLat(), bounds.getSouthWest().getLng())];
    },
  },

  //销毁地图
  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
    }
  },
};
</script>
<style>
html {
  background: radial-gradient(circle, #0c96ff, #092654);
}
.QHpostionDaohang .box {
  padding: 10px;
  font-size: 14px;
}
.QHpostionDaohang span {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
  display: block;
}
.QHpostionDaohang .btn {
  display: inline-block;
  background: #033689;
  height: 36px;
  line-height: 36px;
  padding: 0 5px;
  margin-right: 5px;
  border-radius: 5px;
  color: #fff;
  white-space: nowrap;
  opacity: 0.8;
  text-align: center;
}
.QHpostionDaohang .btn.on {
  opacity: 1;
  background: #f48c0e;
}
.QHpostionDaohang .InputBox{margin-top:6px;}
.QHpostionDaohang .InputBox .btn {
  margin-top: 0;
  border-radius: 0 5px 5px 0;
  height: 38px;
  font-weight: 700;
  background:#37ad47
}
.QHpostionDaohang .InputBox input {
   border-radius:  5px 0 0 5px;
}
.QHpostionDaohang .tabBox .btn2 {
  display: block;
  background: #033689;
  padding:6px 10px;
  margin-right: 10px;
  line-height: 15px;
  border-radius: 0;
  opacity: 0.8;
  border-radius:3px;
}
.QHpostionDaohang .tabBox .btn2.on {
  opacity: 1;
  background: #f48c0e;
  color: #fff;
}

.fixed-info-window {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 320px;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.info-header {
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 8px 8px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  color: #333;
}

.close-btn {
  cursor: pointer;
  font-size: 20px;
  color: #999;
  line-height: 1;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 50%;
  transition: all 0.3s;
}

.close-btn:hover {
  background: #f5f5f5;
  color: #666;
}

.info-content {
  padding: 16px;
  max-height: 400px;
  overflow-y: auto;
}

.MultiMarker .p1 {
  font-size: 16px;
  font-weight: 600;
  color: #1890ff;
  margin-bottom: 8px;
}

.MultiMarker .p0,
.MultiMarker .p3 {
  margin: 6px 0;
  color: #666;
  line-height: 1.5;
}

.MultiMarker .p0 span,
.MultiMarker .p3 span {
  color: #999;
  min-width: 60px;
  display: inline-block;
}

.online {
  color: #52c41a;
  font-weight: 500;
}

.offline {
  color: #f5222d;
  font-weight: 500;
}

.electronicbill-link {
  cursor: pointer;
  color: #1890ff;
  transition: all 0.3s ease;
  padding: 2px 6px;
  border-radius: 4px;
  text-decoration: none;
  position: relative;
}

/* 鼠标悬停效果 */
.electronicbill-link:hover {
  color: #096dd9;
  background-color: rgba(24, 144, 255, 0.1);
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .fixed-info-window {
    width: calc(100% - 40px);
    left: 20px;
    right: 20px;
    bottom: 20px;
  }
}

</style>
